import axios from "../axios";
import {
  getEventsListingForGoPlayRequestParamsFormatter,
  getEventsListingRequestParamsFormatter,
} from "../formatters/searchFormatter";

export const getEventsListing = async (
  offset: number,
  limit: number,
  country?: number,
  city?: number,
  status?: string | null,
  type?: string | null,
  minDate?: string,
  maxDate?: string,
  isMyEvent?: boolean
) => {
  try {
    const params = getEventsListingRequestParamsFormatter(
      offset,
      limit,
      country,
      city,
      status,
      type,
      minDate,
      maxDate,
      isMyEvent
    );
    const response = await axios.get(`/search/events${params}`, {
      headers: { os: "iOS" },
    });
    return response.data;
  } catch (err) {
    throw new Error(err + " Failed to fetch events list");
  }
};

export const getEventsListingForGoPlay = async (minDate?: string, maxDate?: string) => {
  try {
    const params = getEventsListingForGoPlayRequestParamsFormatter(minDate, maxDate);
    const response = await axios.get(`/search/events${params}`, {
      headers: { os: "iOS" },
    });
    return response.data;
  } catch (err) {
    throw new Error(err + " Failed to fetch events list");
  }
};

export const getRecentSearch = async () => {
  try {
    const response = await axios.get(`/search/v1/recent?limit=5&offset=0`);
    return response.data.data;
  } catch (err) {
    throw new Error(err + " Failed to fetch recent searches");
  }
};
